import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import { ProfileAvatar } from '../../components/User/ProfileAvatar';
import { UserStatistic } from '../../components/User/UserStatistic';
import { InputWithPlaceholder } from '../../components/Inputs/InputWithPlaceholder';
import { PhoneInputWithPlaceholder } from '../../components/Inputs/PhoneInputWithPlaceholder';
import Preloader from '../../components/Preloader/Preloader';
import { getStatisticByUserId } from '../../utils/api/services/statistic';
import { updateUser } from '../../utils/api/services/identity';
import MessageModal from '../../components/Modals/MessageModal';
import Enums from "../../utils/enums";
import constants from "../../utils/constants";
import paths from "../../paths";

import {
  parsePhoneNumber,
  validFirstName,
  validLastName,
  validEmail,
  validPhone,
  validPassword,
  validNewPasswordsEquality,
} from "../../utils/validation";

import {
  getDigitsOnly,
} from "../../utils/helpers";


const inputs = {
  firstDataBlock: [
    {
      name: 'firstName',
      placeholder: 'Имя',
      component: InputWithPlaceholder,
      validationFunc: validFirstName
    },
    {
      name: 'lastName',
      placeholder: 'Фамилия',
      component: InputWithPlaceholder,
      validationFunc: validLastName
    },
    {
      name: 'phone',
      type: 'tel',
      placeholder: 'Телефон',
      component: PhoneInputWithPlaceholder,
      validationFunc: validPhone
    },
    {
      name: 'email',
      type: 'email',
      placeholder: 'Email',
      component: InputWithPlaceholder,
      validationFunc: validEmail
    },
  ],
  secondDataBlock: [
    {
      name: 'position',
      placeholder: 'Должность',
    },
    {
      name: 'company',
      placeholder: 'Компания',
    },
    {
      name: 'city',
      placeholder: 'Город',
    },
    // {
    //   name: 'opticalNetwork',
    //   placeholder: 'Оптическая сеть',
    // },
  ],
  passwordBlock: [
    {
      name: 'oldPassword',
      type: 'password',
      placeholder: 'Старый пароль',
    },
    {
      name: 'newPassword',
      type: 'password',
      placeholder: 'Новый пароль',
      validationFunc: validPassword,
    },
    {
      name: 'newPasswordAgain',
      type: 'password',
      placeholder: 'Новый пароль еще раз',
      validationFunc: validPassword
    },
  ],
};

export class MyProfile extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      user: this.props.user,
      newPicture: null,
      popup: null,
      password: {
        oldPassword: '',
        newPassword: '',
        newPasswordAgain: '',
      },
      statistic: {
        visitsCount: this.props.user.visitsCount,
        commentsCount: 0,
        downloadedTrainingMaterialsCount: 0,
        forumTopicCount: 0,
        leftLikesCount: 0,
        practiceCasesCount: 0,
        setLikesCount: 0,
      },
      isLoading: false,
    };
  }

  onUserDataChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;
    this.setState(prevState => ({
      user: {
        ...prevState.user,
        [inputName]: inputValue,
      },
    }));
  };

  onUserPasswordChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value;
    this.setState(prevState => ({
      password: {
        ...prevState.password,
        [inputName]: inputValue,
      },
    }));
  };
  
  handleSubmitBtnClick = (e) => {
    this.setState({ isLoading: true });
    let model = {
      newPicture: this.state.newPicture,
      user: this.state.user,
      password: this.state.password
    };

    if (model.user.phone && model.user.phone.length) {
      model.user.phone = getDigitsOnly(model.user.phone);
    }

    updateUser(model).then(result => {
      let msg = '';
      if (result.code & Enums.updateUserStatusEnum.personalDataUpdated) {
        msg += 'Персональные данные успешно обновлены. ';
      }
      if (result.code & Enums.updateUserStatusEnum.personalDataDoesntUpdated) {
        msg += 'Не удалось обновить персональные данные. ';
      }
      if (result.code & Enums.updateUserStatusEnum.emailConflict) {
        msg += 'Не удалось обновить персональные данные - указанный email привязан к другому аккаунту. ';
      }
      if (result.code & Enums.updateUserStatusEnum.phoneConflict) {
        msg += 'Не удалось обновить персональные данные - указанный номер телефона привязан к другому аккаунту. ';
      }
      if (result.code & Enums.updateUserStatusEnum.passwordChanged) {
        msg += 'Пароль изменён. ';
      }
      if (result.code & Enums.updateUserStatusEnum.passwordDoesntChanged) {
        msg += 'Изменить пароль не удалось, проверьте корректность вводимого пароля. ';
      }

      this.setState({
        popup: {
          message: msg
        }
      });
    }).catch(() => {
      this.setState({
        popup: { message: `Не удалось обновить настройки профиля.` }
      })
    }).finally(() => this.setState({ isLoading: false }));
  }

  setNewPicture = (newPicture) => {
    this.setState({ newPicture });
  }

  componentWillMount = () => {
    getStatisticByUserId(this.props.user.id).then(result => {
      this.setState(prevState => ({
        statistic: {
          ...prevState.statistic,
          ...result 
        }
      }));
    }).catch(e => console.log(e));
  };

  render() {
    const { user, password, statistic, newPicture, isLoading } = this.state;

    const isFirstNameValid = validFirstName(this.state.user.firstName);
    const isLastNameValid = validLastName(this.state.user.lastName);
    const isEmailValid = validEmail(this.state.user.email);
    const isPhoneValid = validPhone(this.state.user.phone);
    const isNewPasswordsEqualityValid = validNewPasswordsEquality(this.state.password.newPassword, this.state.password.newPasswordAgain);
    const isNewPasswordValid = validPassword(this.state.password.newPassword);
    const isNewPasswordAgainValid = validPassword(this.state.password.newPasswordAgain);
    
    return (
      <div className="b-center">
        <BreadCrumbs
          data={[{ url: paths.advocates.main, text: 'Главная' }, { url: paths.advocates.myprofile, text: 'Мой профиль' }]}
        />
        <h1 className="title">Мой профиль</h1>
        <div className="page-container">
          <div className="user-profile user-profile--my-profile clearfix">
            <ProfileAvatar
              canEdit={true}
              user={user}
              newPicture={newPicture}
              setNewPicture={this.setNewPicture}
            />
            <div className="user-profile__block user-profile__personal-info">
              <h2 className="page-subtitle no-margin">Личная информация:</h2>
              <div className="personal-info__row-wrapper">
                {inputs.firstDataBlock.map(item => (
                    <item.component
                      key={item.name}
                      name={item.name}
                      type={item.type}
                      placeholder={item.placeholder}
                      value={user[item.name]}
                      onChange={this.onUserDataChange}
                      validationFunc={item.validationFunc}
                    />
                  ))}
              </div>

              <div className="personal-info__row-wrapper">
                {inputs.secondDataBlock.map(item => (
                  <InputWithPlaceholder
                    key={item.name}
                    name={item.name}
                    type={item.type}
                    placeholder={item.placeholder}
                    value={user[item.name]}
                    onChange={this.onUserDataChange}
                  />
                ))}
              </div>

              <div className="user-profile__password">
                <h2 className="page-subtitle">Смена пароля:</h2>

                {inputs.passwordBlock.map(item => (
                  <InputWithPlaceholder
                    key={item.name}
                    name={item.name}
                    type={item.type}
                    placeholder={item.placeholder}
                    value={password[item.name]}
                    onChange={this.onUserPasswordChange}
                    validationFunc={item.validationFunc}
                  />
                ))}
              </div>
              {!isNewPasswordsEqualityValid &&
                <span className="text-danger field-validation-error">
                  {constants.errorMessage.newPasswordsNotEquals}
                </span>}

              <button
                className="btn personal-info__save-button"
                onClick={this.handleSubmitBtnClick}
                disabled={
                  !isFirstNameValid ||
                  !isLastNameValid ||
                  !isEmailValid ||
                  !isPhoneValid ||
                  !isNewPasswordValid ||
                  !isNewPasswordAgainValid ||
                  !isNewPasswordsEqualityValid ||
                  isLoading}
              >
                Сохранить изменения
              </button>
            </div>

            <UserStatistic statistic={statistic} />
          </div>
        </div>
        {this.state.popup &&
          (<MessageModal
            visible={true}
            title={this.state.popup.title}
            message={this.state.popup.message}
            modificator={this.state.popup.modificator}
            hide={() => {
              this.setState({ popup: null });
              window.location.reload();
            }}
          />)}
      </div>
    );
  }

  static propTypes = {
    user: PropTypes.object.isRequired,
  };
}
